import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
import normalizer from './normalizer'
export type ParamsType = {
  keyword?: string
}

class FetchSearchDataApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_SEARCH_DATA'

    this.config = {
      url: `/v1/search?keyword=${params.keyword}`,
      method: 'GET',
    }
    this.normalizer = normalizer
  }
}

export const fetchSearchData = (params: ParamsType) => getCallApiFunction(new FetchSearchDataApi(params))

class FetchSearchTagDataApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_SEARCH_TAG_DATA'

    this.config = {
      url: `/v1/search/tag?keyword=${params.keyword}`,
      method: 'GET',
    }
    this.normalizer = normalizer
  }
}

export const fetchSearchTagData = (params: ParamsType) => getCallApiFunction(new FetchSearchTagDataApi(params))
